import { render, staticRenderFns } from "./myNews.vue?vue&type=template&id=6a8ffa10"
import script from "./myNews.vue?vue&type=script&lang=js"
export * from "./myNews.vue?vue&type=script&lang=js"
import style0 from "./myNews.vue?vue&type=style&index=0&id=6a8ffa10&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports